import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";

import Success from "./Success";
import Fail from "./Fail";
import Confirm from "./Confirm";
import ChoosePack from "./ChoosePack";

export const ModalSuccess = Success;
export const ModalFail = Fail;
export const ModalConfirm = Confirm;
export const ModalChoosePack = ChoosePack;

export const MODAL_TYPE = {
  SUCCESS: "success",
  FAIL: "fail",
  CONFIRM: "confirm",
};

const BitelModal = ({ data, error, defaultMsg, titleSuccess, btnSuccess, isCancelAction, onClose }) => {
  const { t } = useTranslation();
  const [message, setMessage] = useState(null);
  const [displayModal, setDisplayModal] = useState(false);
  const [modalType, setModalType] = useState(MODAL_TYPE.SUCCESS);

  useEffect(() => {
    if (defaultMsg && (error || data)) {
      // eslint-disable-next-line
      setModalType(data?.errorCode == 0 ? MODAL_TYPE.SUCCESS : MODAL_TYPE.FAIL);
      setMessage(data?.content || error || defaultMsg);
      setDisplayModal(true);
    } else if (error) {
      // eslint-disable-next-line
      setModalType(MODAL_TYPE.FAIL);
      setMessage(error.message);
      setDisplayModal(true);
    } else if (data) {
      setModalType(MODAL_TYPE.SUCCESS);
      setMessage(data.message ? data.message : data.content);
      setDisplayModal(true);
    }
  }, [data, error, t, defaultMsg])

  const closeModal = () => {
    setDisplayModal(false);

    if (onClose) {
      onClose();
    }
  };
  const MyModal = modalType === MODAL_TYPE.SUCCESS ? ModalSuccess : ModalFail;

  return (
    <MyModal
      visible={displayModal}
      message={message}
      title={(modalType === MODAL_TYPE.SUCCESS && !isCancelAction && titleSuccess) || t("notice")}
      btnSuccess={!isCancelAction && btnSuccess}
      handleOk={closeModal}
      handleCancel={closeModal}
    />
  );
}

export default BitelModal;
